import { render, staticRenderFns } from "./FormLayout.vue?vue&type=template&id=116bf9fe&"
import script from "./FormLayout.vue?vue&type=script&lang=js&"
export * from "./FormLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports